import { createFileRoute, Link } from '@tanstack/react-router';
import { type FC } from 'react';

/**
 * Prerendered to /404.html; public/_redirects serves it with a 404 status
 * for any path that isn't a prerendered page or a dashboard rewrite. It's
 * also a normal route so client-side visits to /404 render sensibly.
 */
const NotFound: FC = () => (
  <section className="flex min-h-[70vh] items-center justify-center bg-[#f2f3f1] px-5 pt-24 pb-16">
    <div className="max-w-md text-center">
      <p className="font-mono text-sm font-bold tracking-[0.2em] text-brand-600">404</p>
      <h1 className="font-display mt-3 text-3xl font-bold tracking-tight text-ink-900">
        Page not found
      </h1>
      <p className="mt-4 text-base text-ink-500">
        Sorry, we couldn&rsquo;t find the page you&rsquo;re looking for. It may have moved, but the
        links below should get you back on track.
      </p>
      <div className="mt-8 flex justify-center gap-3">
        <Link
          to="/"
          className="rounded-md bg-brand-600 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-brand-700"
        >
          Go back home
        </Link>
        <Link
          to="/contact"
          className="rounded-md px-6 py-3 text-sm font-semibold text-ink-800 transition-colors hover:text-brand-600"
        >
          Contact us →
        </Link>
      </div>
    </div>
  </section>
);

export const Route = createFileRoute('/_landing/404')({
  head: () => ({
    meta: [
      { title: 'Page not found | Dreams Built' },
      { name: 'robots', content: 'noindex' }
    ]
  }),
  component: NotFound
});
